import { render, staticRenderFns } from "./canvas2d.vue?vue&type=template&id=a7f08fbe"
import script from "./canvas2d.vue?vue&type=script&lang=js"
export * from "./canvas2d.vue?vue&type=script&lang=js"
import style0 from "./canvas2d.vue?vue&type=style&index=0&id=a7f08fbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports